import type {SliderProps} from 'rc-slider';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

export interface RangeSliderProps extends SliderProps {
  min: number;
  max: number;
  value: Array<number>;
}

export function RangeSlider({...props}: RangeSliderProps) {
  return <Slider range {...props} />;
}
